import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import WalletList from './WalletList';

const Wallet = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Carteras' pageTitle='Carteras' />
                <WalletList />
            </div>
        </React.Fragment>
    )
}

export default Wallet;